module.exports = __webpack_public_path__ + "static/media/luta.339cc3be.png";